import { createPortal } from 'react-dom';

import useModalDismiss from './useModalDismiss.js';

// The shared chrome for every schedule/action modal: a backdrop that closes on
// click, and a focus-managed dialog (role/aria-modal/labelledby, focus-on-open,
// Tab trap, Escape, focus restore — all in useModalDismiss). Callers supply the
// heading id (`labelledBy`) and the body; `className` adds a modifier onto the
// base `.schedule-modal` styling.
//
// Rendered through a portal into <body> — a sibling of #root — for two reasons:
// useModalDismiss can mark #root inert without inerting the dialog, and a modal
// nested inside an aria-live region (e.g. CancelOverride's DSR confirm) no longer
// mutates that region on open, which would double-announce its content.
export default function ModalShell({
  labelledBy,
  onClose,
  className = '',
  children,
}) {
  const dialogRef = useModalDismiss(onClose);
  return createPortal(
    <div
      className="schedule-modal__backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className={`schedule-modal ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        tabIndex={-1}
        ref={dialogRef}
        onClick={(event) => event.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
